import * as React from "react";
import { SVGProps } from "react";
const SvgAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 15h-9V6a1 1 0 0 0-2 0v9H6a1 1 0 0 0 0 2h9v9a1 1 0 0 0 2 0v-9h9a1 1 0 0 0 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAdd;
